import React from 'react';

const iconProps = {
  width: 28,
  height: 28,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const stroke = {
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function MarketplaceIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path {...stroke} d='M6 7h12l-1.2 11H7.2L6 7z' />
      <path {...stroke} d='M9 7V5.5A2.5 2.5 0 0 1 11.5 3h1A2.5 2.5 0 0 1 15 5.5V7' />
      <path {...stroke} d='M9 11v4M12 11v4M15 11v4' />
    </svg>
  );
}

export function DatasetSearchIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <circle {...stroke} cx='11' cy='11' r='6' />
      <path {...stroke} d='M16 16l4.5 4.5' />
    </svg>
  );
}

export function WorkflowCreatorIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <circle {...stroke} cx='6' cy='6' r='2.25' />
      <circle {...stroke} cx='18' cy='6' r='2.25' />
      <circle {...stroke} cx='12' cy='18' r='2.25' />
      <path {...stroke} d='M7.8 7.2 10.2 16M13.8 16 16.2 7.2M7.6 7.6 16.4 7.6' />
    </svg>
  );
}

export function WorkflowEditorIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <rect {...stroke} x='4' y='5' width='16' height='14' rx='2' />
      <path {...stroke} d='M8 9h8M8 12h5M8 15h6' />
    </svg>
  );
}

export function DataVisualizationIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path {...stroke} d='M4 19V5M4 19h16' />
      <path {...stroke} d='M8 15V11M12 15V8M16 15V6' />
    </svg>
  );
}

export function MapVisualizationIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path {...stroke} d='M12 3 4 7v10l8 4 8-4V7l-8-4z' />
      <path {...stroke} d='M12 11 4 7M12 11v10M12 11l8-4' />
    </svg>
  );
}

export function FileExplorerIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path {...stroke} d='M4 8.5V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8.5' />
      <path {...stroke} d='M4 8.5h5l1.5-2h8.5V8.5' />
      <path {...stroke} d='M4 8.5 6 5h6l2 3.5' />
    </svg>
  );
}

export function XrVrIcon(props) {
  return (
    <svg {...iconProps} {...props}>
      <path {...stroke} d='M3 9.5v5a2 2 0 0 0 2 2h1.2a1.5 1.5 0 0 0 1.4-1l.9-2.5h6.9l.9 2.5a1.5 1.5 0 0 0 1.4 1H19a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z' />
      <circle {...stroke} cx='8.5' cy='12' r='1.25' />
      <circle {...stroke} cx='15.5' cy='12' r='1.25' />
    </svg>
  );
}
